import { createFileRoute } from '@tanstack/react-router';
import { ORDER_STATUS_MAP } from '@trukt/portal-utils/OrderStatusMap';
import { OrderListRoute, validateOrderListSearch } from './-order-list-route';

export const Route = createFileRoute('/_order-list/orders/canceled')({
  validateSearch: validateOrderListSearch,
  component: () => <OrderListRoute status={ORDER_STATUS_MAP.CANCELED} />,
});
